<template>
  <header class="header site-header">
    <div class="shell header-inner">
      <SiteLogo />
      <nav class="desktop-nav" aria-label="Основная навигация">
        <NuxtLink v-for="link in links" :key="link.to" :to="link.to">{{ link.label }}</NuxtLink>
      </nav>
      <div class="header-actions">
        <NuxtLink to="/calculator" class="button button-small button-outline header-estimate"
          >Рассчитать проект</NuxtLink
        >
        <NuxtLink to="/cart" class="cart-link" :aria-label="`Корзина, товаров: ${count}`"
          ><svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M3 3h2l2.5 12h11l2-8H6M9 20h.01M18 20h.01" /></svg
          ><span v-if="count" class="cart-count">{{ count }}</span></NuxtLink
        >
        <button
          ref="menuButton"
          class="menu-toggle"
          :aria-label="open ? 'Закрыть меню' : 'Открыть меню'"
          aria-controls="site-mobile-nav"
          :aria-expanded="open"
          @click="open = !open"
        >
          <span /><span />
        </button>
      </div>
    </div>
    <nav v-if="open" id="site-mobile-nav" class="mobile-nav" aria-label="Мобильная навигация">
      <NuxtLink v-for="link in links" :key="link.to" :to="link.to" @click="open = false">{{
        link.label
      }}</NuxtLink
      ><NuxtLink to="/calculator" @click="open = false">Рассчитать проект</NuxtLink
      ><NuxtLink to="/cart" @click="open = false">Корзина · {{ count }}</NuxtLink>
    </nav>
  </header>
</template>
<script setup lang="ts">
import { useCart } from '~/core/composables/useCart';
const { count } = useCart();
const open = ref(false);
const menuButton = ref<HTMLButtonElement>();
const route = useRoute();
const links = [
  { to: '/products', label: 'Оборудование' },
  { to: '/services', label: 'Установка' },
  { to: '/#system', label: 'Система Robotics Vision' },
  { to: '/partnership', label: 'Сотрудничество' },
  { to: '/contacts', label: 'Контакты' },
];
watch(
  () => route.fullPath,
  () => {
    open.value = false;
  },
);
const onKey = (event: KeyboardEvent) => {
  if (event.key === 'Escape' && open.value) {
    open.value = false;
    menuButton.value?.focus();
  }
};
onMounted(() => document.addEventListener('keydown', onKey));
onBeforeUnmount(() => document.removeEventListener('keydown', onKey));
</script>
